import RelationshipMetadata from "../../RelationshipMetadata";

class AdminRoleAdminRoleEmployeeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminRoleAdminRoleEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminRole";
        this.childEnterpriseComponent = "AdminRoleEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default AdminRoleAdminRoleEmployeeRelationshipMetadata;